import { Nullable } from '@/shared/types/app.types'

export interface StatisticalInfoPaginatorTrackingItems {
    label: string
    key: string
    value?: number
}

export interface StatisticalInfoPaginatorState {
    externalLoading: boolean
    indexSelected: number
    selected: Nullable<StatisticalInfoPaginatorTrackingItems>
}
export const initialStatisticalInfoPaginatorState =
    (): StatisticalInfoPaginatorState => ({
        externalLoading: false,
        indexSelected: 0,
        selected: null
    })
